import React, { useState } from 'react';
import './card-sec3.css'
import pic8 from '../../assets/pic8.png'
import pic9 from '../../assets/pic9.png'
import pic10 from '../../assets/pic10.png'
import pic11 from '../../assets/pic11.png'
import { useTranslation } from 'react-i18next';

const CardSec3 = (props) => {
const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';



     const [flipped, setFlipped] = useState(false);

    return ( 
   <div 
      className={`card-flip-container ${flipped ? 'flipped' : ''}`} 
      onClick={() => setFlipped(!flipped)}
    >
      <div className="card-sec3-inner">



       <article className='card-sec3'>
        <figure className='cont-img-sec3'>
            <img className='img-sec3' src={props.img} alt='pic'>
            </img>
            <article className='white-rect'>{props.title5}</article>
        </figure>

            <article className='text-card-sec3'>
                <article className='article-sec3'>
                    <h2 className='event-ttile'>{props.title}</h2>
                    <article className='event-info-sec3'>
                        <article className='row-card-sec3'>
                            <img className='icons-sec3' src={pic9} alt='date'></img>
                            <h3 className='date-card-sec3'>{props.title2}</h3>
                        </article>
                         <article className='row-card-sec3'>
                            <img className='icons-sec3' src={pic10} alt='time'></img>
                            <h3 className='date-card-sec3'>{props.title3}</h3>
                        </article>
                        <article className='row-card-sec3'>
                            <img className='icons-sec3' src={pic11} alt='location'></img>
                            <h3 className='date-card-sec3'>{props.title4}</h3>
                        </article>
                    </article>
                </article>
                <h2 className='price-price'>{props.price}</h2>
            </article>

            <img className='circle-card-sec3' src={pic8} alt='pic'></img>
            <h3 dir={direction} className='viewmore-sec3'>{t('View Details')}</h3>
       </article>


         <article className="card-side card-back">
          <article className="back-content-sec3">
            <h2 className="event-ttile">{props.title}</h2>
            <p className="description">{props.description}</p>
          </article>
        </article>

      </div>
 
</div>

     );
}

export default CardSec3;